import React from "react";

const ReportsIcon = props => {
    const color = props.color;
    return (
        <svg width={20} height={16} {...props}>
            <path
            d="M4.134 13.09a2.067 2.067 0 1 1-4.135-.002 2.067 2.067 0 0 1 4.135.002zm0-5.512a2.067 2.067 0 1 1-4.135 0 2.067 2.067 0 0 1 4.135 0zm15.156 4.478v2.067a.354.354 0 0 1-.345.344H5.855a.354.354 0 0 1-.344-.344v-2.067c0-.183.162-.344.345-.344h13.09c.182 0 .344.161.344.344zM4.134 2.066a2.067 2.067 0 1 1-4.135 0 2.067 2.067 0 0 1 4.135 0zM19.29 6.546v2.067a.354.354 0 0 1-.345.344H5.855a.354.354 0 0 1-.344-.344V6.545c0-.183.162-.345.345-.345h13.09c.182 0 .344.162.344.345zm0-5.512V3.1a.354.354 0 0 1-.345.345H5.855a.354.354 0 0 1-.344-.345V1.033c0-.183.162-.344.345-.344h13.09c.182 0 .344.161.344.344z"
            fill={color}
            fillRule="evenodd"
            />
        </svg>
    );
};

export default ReportsIcon;


// WEBPACK FOOTER //
// ./src/components/Menu/MenuIcons/ReportsIcon.js